import { createContext, useContext, useState } from "react";

interface PanelContextType {
  isRightPanelVisible: boolean;
  setIsRightPanelVisible: (visible: boolean) => void;
  toggleRightPanel: () => void;
}

const PanelContext = createContext<PanelContextType | null>(null);

export function usePanelContext() {
  const context = useContext(PanelContext);
  if (!context) {
    throw new Error("usePanelContext must be used within a PanelProvider");
    }
  return context;
}

interface PanelProviderProps {
  children: React.ReactNode;
}

export function PanelProvider({ children }: PanelProviderProps) {
  const [isRightPanelVisible, setIsRightPanelVisible] = useState(true);

  const toggleRightPanel = () => {
    setIsRightPanelVisible(!isRightPanelVisible);
  };

  return (
    <PanelContext.Provider
      value={{
        isRightPanelVisible,
        setIsRightPanelVisible,
        toggleRightPanel,
      }}
    >
      {children}
    </PanelContext.Provider>
  );
}
